import { render, staticRenderFns } from "./ProductAttributesDropdowns.vue?vue&type=template&id=fc4b3b46&scoped=true&"
import script from "./ProductAttributesDropdowns.vue?vue&type=script&lang=js&"
export * from "./ProductAttributesDropdowns.vue?vue&type=script&lang=js&"
import style0 from "./ProductAttributesDropdowns.vue?vue&type=style&index=0&id=fc4b3b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc4b3b46",
  null
  
)

export default component.exports